"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUseSignalREffect = void 0;
var hermes_channel_1 = __importDefault(require("hermes-channel"));
var react_1 = require("react");
var utils_1 = require("../utils");
var utils_2 = require("./utils");
function createUseSignalREffect(context) {
  var useSignalREffect = function useSignalREffect(callback) {
    var callbackRef = (0, utils_1.useEvent)(callback);
    (0, react_1.useEffect)(function () {
      function _callback(data) {
        callbackRef(data);
      }
      hermes_channel_1.default.on((0, utils_2.getMessageEvent)(context), _callback);
      return function () {
        hermes_channel_1.default.off((0, utils_2.getMessageEvent)(context), _callback);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  };
  return useSignalREffect;
}
exports.createUseSignalREffect = createUseSignalREffect;